import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { IScene, ISceneLightShow } from '../../../../types/Scenes/scenesTypes';
import { SideBarDeleteActionWithPopup } from '../../../../components/commons/SideBarComponents/DeleteActionWithPopup/sideBarDeleteActionWithPopup';
import {
  StyledContainerItems,
  StyledContainerFooterSideBar,
  StyledTitleSideBar
} from '../../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../../i18n';
import { SideBarSimpleMethodItem } from '../../../../components/commons/SideBarComponents/SimpleMethodItem/sideBarSimpleMethodButtonItem';
import {
  useDeleteSceneMutation,
  useExecuteSceneMutation,
  useResaveSceneMutation
} from '../../../../services/scenes/sceneService';

interface ISceneDetailsProps {
  scene: ISceneLightShow;
  selectedScenes: ISceneLightShow[];
  setSelectedScenes: (scenes: ISceneLightShow[]) => void;
  openSideBar: boolean;
  setOpenSideBar: (openSideBar: boolean) => void;
  reloadTable: () => void;
}
export const SceneLightShowDetails = ({
  scene,
  openSideBar,
  selectedScenes,
  setSelectedScenes,
  setOpenSideBar,
  reloadTable
}: ISceneDetailsProps) => {
  const [execute, { isSuccess: isSuccessExecute }] = useExecuteSceneMutation();
  const [deleteSc, { isSuccess: isSuccessDelete, isError, error }] =
    useDeleteSceneMutation();
  const deleteScene = () => {
    deleteSc(scene.sceneId);
  };

  const [resaveScene, { isSuccess: isSuccessResave }] =
    useResaveSceneMutation();

  const executeScene = () => {
    execute(scene.sceneId);
  };

  const handleResaveScene = () => {
    resaveScene(scene.sceneId);
  };

  useEffect(() => {
    if (isError) {
      const msg = (error as any)?.data?.message ?? 'error deleting scene';
      toast.error(msg);
    }
  }, [isError]);

  useEffect(() => {
    if (isSuccessExecute) {
      setOpenSideBar(false);
      setSelectedScenes([]);
      toast.success(Strings.scenes.successExecuteScene);
    }
  }, [isSuccessExecute]);

  useEffect(() => {
    if (isSuccessDelete) {
      setOpenSideBar(false);
      setSelectedScenes([]);
      toast.success(Strings.scenes.successDeleteScene);
      reloadTable();
    }
  }, [isSuccessDelete]);

  useEffect(() => {
    if (isSuccessResave) {
      setOpenSideBar(false);
      setSelectedScenes([]);
      toast.success(Strings.scenes.successResaveScene);
    }
  }, [isSuccessResave]);

  useEffect(() => {
    if (!openSideBar) {
      setSelectedScenes([]);
    }
  }, [openSideBar]);
  return (
    <>
      {scene && (
        <>
          <StyledContainerItems>
            <StyledTitleSideBar>{scene?.name}</StyledTitleSideBar>

            <SideBarSimpleMethodItem
              name={Strings.scenes.executeScene}
              action={() => executeScene()}
              successAction={false}
              textSuccess="success"
            />
            <SideBarSimpleMethodItem
              name={Strings.scenes.resaveScene}
              action={() => handleResaveScene()}
              successAction={false}
              textSuccess="success"
            />
            <SideBarDeleteActionWithPopup
              onDelete={() => deleteScene()}
              titleConfirmation={Strings.scenes.deleteSceneTitle}
              textConfirmation={Strings.common.thisActionIsIrreversible}
              textIcon={Strings.scenes.deleteScene}
            />
          </StyledContainerItems>

          <StyledContainerFooterSideBar>
            <button
              type="button"
              className="btn-cancel"
              onClick={() => {
                setOpenSideBar(false);
                setSelectedScenes([]);
              }}
            >
              {Strings.common.cancel}
            </button>
          </StyledContainerFooterSideBar>
        </>
      )}
      <div />
    </>
  );
};
